export const i18nReportsPage = {
  summary: {
    title: 'Asset Health',
    severity: {
      status: {
        title: 'Condition Deviations',
        caseTitle: 'Cases',
        4: 'Very High',
        3: 'High',
        2: 'Medium',
        1: 'Low',
        TOTAL: 'Total',
        modec: {
          5: 'Critical Condition',
          4: 'Potential Problem',
          3: 'Alarm Condition',
          2: 'Not Monitored',
          1: 'Not Operated',
          0: 'Normal condition',
          TOTAL: 'Total',
        },
      },
    },
    actions: {
      pdf: 'Report',
    },
  },
  assetsList: {
    columns: { health: 'Health', asset: 'Asset' },
  },
  home: {
    common: { reports: 'Relatórios', rert: 'RERT Health Score', performance: 'Performance' },
    description: {
      performance:
        "Performance Report monitors production performance KPI's per system and vessels: Oil production, Produced Water, Gas Dehydration and IUGA.",
      rert: 'RERT is a montly report that provides the Health score for all plants with drilldown navigation per system and sub systems, showing associated condition deviations.',
    },
  },
  labels: {
    confirm: 'Confirm',
    CSV: 'CSV',
    goToPi: 'Go to PI',
    noData: 'Sorry, report is not available.',
    pdf: 'PDF',
  },
  pdfModal: {
    title: 'Export Monthly Report',
    labels: {
      vessel: 'Select a Vessel',
      month: 'Month',
      documentName: 'Document Name',
    },
    buttons: {
      cancel: 'Cancel',
      generate: 'Download PDF',
    },
    error: 'PDF unavailable for this asset',
  },
  commentModal: {
    labels: {
      error: 'Error',
      fieldPlaceholder: 'Enter comments',
      modalTitle: 'Comment for day ',
      save: 'Save',
      success: 'Success',
    },
    messages: {
      success: 'Changes applied successfully!',
      error: 'Please, try again or contact support',
    },
  },
  modalSuccess: {
    done: 'Done',
    successfulConditionDeviation: 'The condition deviation was successfuly created',
    successEditCD: 'The condition deviation was successfuly updated',
  },
};
